export default "__VITE_ASSET__NK1BjvjK__"